/* eslint-disable */
import {createApp} from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import plugin from '@/plugin'

import BootstrapVue from 'bootstrap-vue-3';
import 'bootstrap/dist/css/bootstrap.min.css';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import PrimeVue from 'primevue/config'
import 'primevue/resources/themes/lara-light-indigo/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import AutoComplete from 'primevue/autocomplete'
import TreeTable from 'primevue/treetable'
import Tree from 'primevue/tree'
import Column from 'primevue/column'
import Button from 'primevue/button'
import Checkbox from 'primevue/checkbox'
import ganttastic from '@infectoone/vue-ganttastic'
import ConfirmationService from 'primevue/confirmationservice';

import 'vuetify/styles';
import {createVuetify} from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import dayjs from 'dayjs'

const app = createApp(App)

const vuetify = createVuetify({
    components,
    directives,
})

app.use(router)
app.use(store)
app.use(plugin)
app.use(BootstrapVue)
app.use(vuetify)
app.use(dayjs)
app.use(ganttastic)
app.use(ConfirmationService);

const options = {
    // You can set your default options here
};

app.use(Toast, options);
app.use(PrimeVue)

app.component('AutoComplete', AutoComplete)
app.component('TreeTable', TreeTable)
app.component('Column', Column)
app.component('Button', Button)
app.component('Checkbox', Checkbox)
app.component('Tree', Tree)

app.mount('#app')
